import React, { useState } from 'react';
import './OtherServicesBoxes.css';
import './PediatricOrthopedics.css'; 
import PediatricCard from './PediatricOrtho'; // Make sure the path is correct

function Card2() {
    const [activeIndex, setActiveIndex] = useState(0); // no card selected initially

    const services = [
        {
            id: 1,
            name: 'TKR Surgery',
            icon: '/tkr-surgery-blue.png',
            cardinfo: {
                title: 'TKR Surgery',
                subtitle: 'TKR Surgery',
                description: 'Therapy-Free Total Knee Replacement is an advanced approach to knee replacement surgery designed to help patients recover faster without the need for prolonged physiotherapy. ',
                imageUrl: '/TKR.jpg.jpeg',
                buttonurl:'/Therapy_Free_Total_Knee_Replacement_by_dr_garlapti_siva_srikar_guntur',
            },

        },
        {
            id: 2,
            name: 'THR Surgery',
            icon: '/thr-surgery-blue.png',
            cardinfo: {
                title: 'THR Surgery',
                subtitle: 'Total Hip Replacement Surgical',
                description: 'Total Hip Replacement (THR) is a surgical procedure performed to replace a damaged or diseased hip joint with an artificial implant.',
                imageUrl: '/THR.jpg.jpeg',
                buttonurl:'/Total_Hip_Replacement_by_dr_garlapati_sivasrikar_guntur',
            },

        },
        {
            id: 3,
            name: 'Arthroscopy',
            icon: '/arthrioscopy.png',
            cardinfo: {
                title: 'Arthroscopy',
                subtitle: 'Arthroscopy Surgery',
                description: 'Arthroscopy (Keyhole Surgery) is a minimally invasive surgical procedure used to diagnose and treat various joint problems.',
                imageUrl: '/ARTHROSCOPY.jpg.jpeg',
                buttonurl:'/Arthroscopy_Key_Hole_Surgery_by_dr_garlapati_sivasrikar_guntur',
            },

        },
        {
            id: 4,
            name: 'Sports Medicine',
            icon: '/sportws-med.png',
            cardinfo: {
                title: 'Sports Medicine',
                subtitle: 'Care for Sports Injuries',
                description: 'Ligament injuries in the knee and shoulder are common among athletes and individuals involved in physical activities.',
                imageUrl: '/SPORTS MEDICINE.jpg.jpeg',
                buttonurl:'/Ligament_Repairs_in_Knee_and_Shoulder_Sports_Injuries_by_dr_garlapati_sivasrikar_gutur',
            },

        },
        {
            id: 5,
            name: 'General Ortho',
            icon: '/general-ortho.png',
            cardinfo: {
                title: 'General Ortho',
                subtitle: 'General Orthopedics',
                description: 'General Orthopedics focuses on the diagnosis, treatment, and management of conditions related to the bones, joints, muscles, ligaments, and tendons.',
                imageUrl: '/General ortho.jpg.jpeg',
                buttonurl:'/General_Ortho_by_dr_garlapati_sivasrikar_guntur',
            },
        },
        {
            id: 6,
            name: 'Polytrauma',
            icon: '/POLYTRAUMA ICON.png',
            cardinfo: {
                title: 'Polytrauma',
                subtitle: 'Polytrauma',
                description: 'Polytrauma refers to a serious medical condition where a patient suffers multiple injuries affecting different parts of the body, often due to major accidents such as road traffic accidents, falls from height, or severe trauma.',
                imageUrl: '/POLYTRAUMA IMAGE.jpeg',
                buttonurl:'/Polytrauma_Treatment_by_garlapati_siva_srikar_guntur',
            },
        },
    ];

    // Get currently active service
    const activeService = activeIndex !== null ? services[activeIndex] : null;

    return (
        <div className="other-services-container">
            {/* Cards */}
            <div className="services-containerr">
                {services.map((service, index) => (
                    <div
                        key={service.id}
                        className={`service-cardr ${activeIndex === index ? 'active' : ''}`}
                        onClick={() => setActiveIndex(index)}
                    >
                        <div className="icon-wrapperr">
                            <img src={service.icon} alt={service.name} />
                        </div>
                        <p>{service.name}</p>
                    </div>
                ))}
            </div>

            {/* Render PediatricCard or other card below all cards */}
            {activeService && activeService.cardinfo && (
                <div className="pediatric-card-wrapper">
                    <PediatricCard
                        title={activeService.cardinfo.title}
                        subtitle={activeService.cardinfo.subtitle}
                        description={activeService.cardinfo.description}
                        imageUrl={activeService.cardinfo.imageUrl}
                        buttonurl={activeService.cardinfo.buttonurl}
                    />
                </div>
            )}
        </div>
    );
}

export default Card2;